import React, {FC} from 'react';
import {Outlet} from 'react-router-native';
import {useApp} from '@app';
import {AuthRedirect} from './AutomaticRedirects';

const RequireAuth: FC = () => {
  const {authorization} = useApp();

  return authorization ? <Outlet /> : <AuthRedirect />;
};

export {RequireAuth};
